import { toast } from 'sonner';

// Default Sonner options
const initialOptions = {
  position: 'top-center',
  duration: 3000,
};

// Unified toast API, compatible with previous signature
export const showToast = (message, type = 'info', options = {}) => {
  const toastOptions = {
    ...initialOptions,
    ...options,
  };

  switch (type) {
    case 'success':
      toast.success(message, toastOptions);
      break;
    case 'error':
      toast.error(message, toastOptions);
      break;
    case 'warning':
      toast.warning(message, toastOptions);
      break;
    case 'info':
      toast.info(message, toastOptions);
      break;
    default:
      toast(message, toastOptions);
      break;
  }
};
